export type Theme = 'light' | 'dark';

export const getThemeName = (): Theme => {
  //  Retrieves the current theme from the document's body class.
  const bodyClass = document.body.className;
  const themeName = bodyClass.match(/Theme-([^\s]+)/)?.[1] || 'light';
  return themeName === 'dark' ? 'dark' : 'light';
};
